<div class="login-block">
    <div class="login-box">
        <div class="login-container">
            <div class="part-2 px-4 pt-4">
                <div class="part-2-container">
                    <form #l="ngForm" (ngSubmit)="changeuserpassword(l)" autocomplete="off">
                        <div class="d-flex">
                            <div>
                                <h4 class="pb-4">Change Password</h4>
                            </div>
                            <div class="ml-auto">
                                <button mat-icon-button (click)="onNoclick()">
                                    <ion-icon name="close-outline"></ion-icon>
                                </button>
                            </div>
                        </div>
                        <app-password-control label="Current Password" [(ngModel)]="user.currentPassword"
                            name="currentPassword" required [errorTrue]="errorTrue" [disabled]="data.btnClicked"
                            [mandatory]="true">
                        </app-password-control>
                        <app-password-control label="New Password" [(ngModel)]="user.newPassword" name="newPassword"
                            required
                            [errorTrue]="(user.newPassword !== '' && newPassword.invalid ? 'Password Invalid' : '') || errorTrue"
                            [disabled]="data.btnClicked" [mandatory]="true" [strength]="true" [pattern]="data.pattern"
                            #newPassword="ngModel"
                            errorText="{{ user.newPassword !== '' && newPassword.invalid ? 'Password Invalid' : ''}}">
                        </app-password-control>
                        <!-- <app-password-control label="New Password" [(ngModel)]="user.newPassword" name="newPassword"
                            required
                            [errorTrue]="errorTrue && (user.newPassword !== '' && newPassword.invalid ? 'Password Invalid' : '')"
                            [disabled]="data.btnClicked" [mandatory]="true" [strength]="true" [pattern]="data.pattern"
                            #newPassword="ngModel"
                            errorText="{{ user.newPassword !== '' && newPassword.invalid ? 'Password Invalid' : ''}}">

                        </app-password-control> -->



                        <app-password-control label="Confirm Password" [(ngModel)]="user.confirmPassword"
                            name="confirmPassword" required [disabled]="data.btnClicked" [mandatory]="true"
                            [errorTrue]="errorTrue" [strength]="true"
                            errorText="{{(user.newPassword !== user.confirmPassword) && user.confirmPassword !== '' ? 'Password Mismatch' : ''}}">
                        </app-password-control>




                        <div class="pt-2"></div>
                        <button mat-raised-button color="primary" type="submit" class="lg-btn"
                            [disabled]="data.btnClicked">
                            <ng-container *ngIf="!data.btnClicked">Set Password </ng-container>
                            <ng-container *ngIf="data.btnClicked">
                                <app-dot></app-dot>
                            </ng-container>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>